<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Sync Member With HubSpot
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        />
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-cancel-warning">
        Do you want to sync this member info with HubSpot?
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-cancel-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="syncWithHubspot"
      >
        Sync
      </button>
    </div>
    <ProcessOverlay
      :show="syncing"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

import apiClient from '@shared/lib/general/apiClient';

export default {
  name: 'SyncHubspot',
  mixins: [customerDetailMixin],
  components: {
    ProcessOverlay,
  },
  data() {
    return {
      syncing: false,
    };
  },
  methods: {
    async syncWithHubspot() {
      this.syncing = true;
      try {
        await apiClient({
          method: 'GET',
          url: `/customers/update/${this.customer.id}/hubspot`,
        });
        this.$store.dispatch('showSuccessToast', {
          message: 'HubSpot sync was successful.',
        });
        this.toggleActionModal(false);
      } catch (err) {
        console.error(err);
      }
      this.syncing = false;
    },
  },
};
</script>
